
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => {
    return {
        container: {
            overflowY: "auto",
            height: `calc(100% - 60px)`,
        },
        footer: {
            position: 'absolute',
            display: "flex",
            justifyContent: "center",
            bottom: theme.spacing(4),
            width: '100%',
            "& button": {
                width: "40%",
            }
        },

    };
});
